export default "__VITE_ASSET__BxylWiFD__"